import { default as Container } from './TopSubscribersSection.container';
import { default as Component } from './TopSubscribersSection';
export default Container(Component);
